import { render, staticRenderFns } from "./waterDialog.vue?vue&type=template&id=566e0a89"
import script from "./waterDialog.vue?vue&type=script&lang=js"
export * from "./waterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports